var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-template",
    [
      _c("template", { slot: "page-content" }, [
        _c(
          "div",
          {
            staticClass:
              "generic--template waste-page--template page-template bg-beige pb5",
          },
          [
            _c("div", { staticClass: "relative z-content" }, [
              _c(
                "div",
                { staticClass: "relative container-fluid mw9 center" },
                [
                  _c("div", { staticClass: "row relative center mb0 mt4-ns" }, [
                    _c(
                      "div",
                      { staticClass: "w-100 col-sm-6" },
                      [
                        _vm.page.has_bg_video
                          ? _c("bg-vimeo-video", {
                              attrs: {
                                vimeoVideoId:
                                  _vm.page.background_video_vimeo_id,
                              },
                            })
                          : _vm.page.hero_image
                          ? _c("img", {
                              staticClass: "img-responsive",
                              attrs: { src: _vm.page.hero_image },
                            })
                          : _c("img", {
                              directives: [
                                {
                                  name: "lazy",
                                  rawName: "v-lazy",
                                  value: "/uploads/9084_Aug10_Gorlin.jpg",
                                  expression:
                                    "'/uploads/9084_Aug10_Gorlin.jpg'",
                                },
                              ],
                              staticClass: "img-responsive",
                            }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "relative col-xs-12 col-sm-5 col-md-offset-1 ph0",
                      },
                      [
                        _c(
                          "h1",
                          {
                            staticClass:
                              "db dn-ns f-page-title ttu tl center lh-heading pr0-ns is-blenny is-navy mw7-ns",
                          },
                          [_vm._v(_vm._s(_vm.page.seo_title))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "dn db-ns abs-vert-center ml0 ml4-m" },
                          [
                            _c(
                              "h1",
                              {
                                staticClass:
                                  "mw7-ns tl center lh-heading f-page-title ttu is-blenny is-navy",
                              },
                              [_vm._v(_vm._s(_vm.page.seo_title))]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("section", { staticClass: "relative" }, [
                _c(
                  "div",
                  { staticClass: "relative container-fluid mw9 center" },
                  [
                    _c("div", { staticClass: "row center" }, [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-6 mt0 mt5-ns" },
                        [
                          _vm.page.intro_text
                            ? _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-xs-12 col-sm-12 pb4" },
                                  [
                                    _c(
                                      "h3",
                                      {
                                        staticClass:
                                          "f2 mb3 is-tablet-bold is-navy lh-title",
                                      },
                                      [_vm._v(_vm._s(_vm.page.headline_text))]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass:
                                        "f22px is-tablet-regular link-bold lh-copy cms-content",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.marked(_vm.page.intro_text)
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dn dn-m db-l col-sm-3 col-sm-offset-1",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "dn db-ns icon-image relative nt5 center",
                            },
                            [
                              _c("img", {
                                staticClass:
                                  "db relative center w-100 mw20rem z-0",
                                attrs: { src: _vm.page.secondary_image },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row center" }, [
                      _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                        _c(
                          "h2",
                          { staticClass: "f1 mw7 ttu is-blenny is-navy" },
                          [_vm._v(_vm._s(_vm.page.clean_vibes_headline))]
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "relative z-content" }, [
              _c(
                "div",
                { staticClass: "relative container-fluid mw8 center" },
                [
                  _c(
                    "div",
                    { staticClass: "row relative center mb4 mt4-ns is-black" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-6 mt5" },
                        [
                          _vm.page.waste_content.sub_header_text
                            ? _c(
                                "h2",
                                {
                                  staticClass: "f2 is-tablet-bold is-navy mb4",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.page.waste_content.sub_header_text
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(
                            _vm.page.waste_content.list,
                            function (item, index) {
                              return _c("div", { staticClass: "row mb4" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-xs-3 col-sm-3" },
                                  [
                                    _c("simple-svg", {
                                      staticClass:
                                        "db relative w3 waste-navy-svg",
                                      attrs: { filepath: item.image },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-xs-9 col-sm-9" },
                                  [
                                    _c(
                                      "h3",
                                      {
                                        staticClass:
                                          "is-tablet-cond-bold f25px mb2 is-navy",
                                      },
                                      [_vm._v(_vm._s(item.title))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "is-tablet-wide-bold f35px mb2 is-navy",
                                      },
                                      [_vm._v(_vm._s(item.tons))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "is-tablet-bold f15px is-red",
                                      },
                                      [_vm._v(_vm._s(item.pounds))]
                                    ),
                                  ]
                                ),
                              ])
                            }
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "db relative" },
                            _vm._l(
                              _vm.page.waste_content.totals_list,
                              function (item, index) {
                                return _c("div", {}, [
                                  _c(
                                    "h3",
                                    {
                                      staticClass:
                                        "is-tablet-bold f25px mb2 is-navy",
                                    },
                                    [
                                      _vm._v(_vm._s(item.text)),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "dib f4 is-tablet-bold is-red",
                                        },
                                        [_vm._v(_vm._s(item.pounds))]
                                      ),
                                    ]
                                  ),
                                ])
                              }
                            ),
                            0
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-6 mt2 mt5-ns" },
                        [
                          _c(
                            "h3",
                            { staticClass: "is-tablet-bold f20px mb2 is-navy" },
                            [
                              _vm._v(
                                _vm._s(_vm.page.recycling_breakdown.title) +
                                  " 1"
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(
                            _vm.page.recycling_breakdown.list,
                            function (item, index) {
                              return _c(
                                "div",
                                { staticClass: "db relative mv4" },
                                [
                                  _c(
                                    "h4",
                                    {
                                      staticClass:
                                        "is-tablet-regular f4 mb3 is-navy",
                                    },
                                    [_vm._v(_vm._s(item.title))]
                                  ),
                                  _vm._v(" "),
                                  _c("img", {
                                    directives: [
                                      {
                                        name: "lazy",
                                        rawName: "v-lazy",
                                        value: item.image,
                                        expression: "item.image",
                                      },
                                    ],
                                    staticClass: "dib relative",
                                    class: {
                                      w86px: index == 2,
                                      w52px: index == 3,
                                      w51px: index == 4,
                                      w29px: index == 5,
                                    },
                                    attrs: {
                                      alt:
                                        "2019 Waste Diversion Graphic" + index,
                                    },
                                  }),
                                ]
                              )
                            }
                          ),
                        ],
                        2
                      ),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm.isWindowWidthMobile == true &&
            _vm.page.featured_content_section.is_published
              ? _c(
                  "div",
                  { staticClass: "relative bg-light-blue z-content mb5" },
                  [
                    _c(
                      "section",
                      { staticClass: "relative center pv4 is-black" },
                      [
                        _c(
                          "swiper",
                          {
                            ref: "mySwiper",
                            attrs: { options: _vm.swiperOptions },
                          },
                          [
                            _c("swiper-slide", [
                              _c(
                                "div",
                                { staticClass: "relative container-fluid" },
                                [
                                  _c("div", { staticClass: "db w-100" }, [
                                    _c("img", {
                                      staticClass:
                                        "db relative center img-responsive w-100",
                                      attrs: {
                                        src: _vm.page.featured_content_section
                                          .content["0"].image,
                                        alt: _vm.page.featured_content_section
                                          .content["0"].image.alt,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "h3",
                                      {
                                        staticClass:
                                          "f20px is-tablet-cond-bold mt4 mb3",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.page.featured_content_section
                                              .content["0"].title
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "f15px is-tablet-regular mb3 lh-copy",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.page.featured_content_section
                                              .content["0"].text
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "f15px is-tablet-bold",
                                        attrs: {
                                          title:
                                            _vm.page.featured_content_section
                                              .content["0"].link_title,
                                          href: _vm.page
                                            .featured_content_section.content[
                                            "0"
                                          ].link,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.page.featured_content_section
                                              .content["0"].button_text
                                          )
                                        ),
                                        _c("simple-svg", {
                                          staticClass: "checkout",
                                          attrs: {
                                            filepath:
                                              "/uploads/checkout-arrow.svg",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("swiper-slide", [
                              _c(
                                "div",
                                { staticClass: "relative container-fluid" },
                                [
                                  _c("div", { staticClass: "db w-100" }, [
                                    _c("img", {
                                      staticClass:
                                        "db relative center img-responsive w-100",
                                      attrs: {
                                        src: _vm.page.featured_content_section
                                          .content["1"].image,
                                        alt: _vm.page.featured_content_section
                                          .content["1"].image.alt,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "h3",
                                      {
                                        staticClass:
                                          "f20px is-tablet-cond-bold mt4 mb3",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.page.featured_content_section
                                              .content["1"].title
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "f15px is-tablet-regular mb3 lh-copy",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.page.featured_content_section
                                              .content["1"].text
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "f15px is-tablet-bold",
                                        attrs: {
                                          title:
                                            _vm.page.featured_content_section
                                              .content["1"].link_title,
                                          href: _vm.page
                                            .featured_content_section.content[
                                            "1"
                                          ].link,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.page.featured_content_section
                                              .content["1"].button_text
                                          )
                                        ),
                                        _c("simple-svg", {
                                          staticClass: "checkout",
                                          attrs: {
                                            filepath:
                                              "/uploads/checkout-arrow.svg",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isWindowWidthMobile == false &&
            _vm.page.featured_content_section.is_published
              ? _c(
                  "div",
                  { staticClass: "relative bg-pink z-content mb5 mt4" },
                  [
                    _c("div", { staticClass: "relative container-fluid" }, [
                      _c(
                        "section",
                        { staticClass: "relative center mw8 pt5 pb5 is-black" },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-xs-12 col-sm-6 pr5-ns br-ns b--is-cream",
                              },
                              [
                                _c("img", {
                                  staticClass:
                                    "db relative center img-responsive w-100",
                                  attrs: {
                                    src: _vm.page.featured_content_section
                                      .content["0"].image,
                                    alt: _vm.page.featured_content_section
                                      .content["0"].image.alt,
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "f20px is-tablet-cond-bold mt4 mb3",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.page.featured_content_section
                                          .content["0"].title
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "f15px is-tablet-regular mb3 lh-copy",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.page.featured_content_section
                                          .content["0"].text
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "f15px is-tablet-bold",
                                    attrs: {
                                      title:
                                        _vm.page.featured_content_section
                                          .content["0"].link_title,
                                      href: _vm.page.featured_content_section
                                        .content["0"].link,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.page.featured_content_section
                                          .content["0"].button_text
                                      )
                                    ),
                                    _c("simple-svg", {
                                      staticClass: "checkout",
                                      attrs: {
                                        filepath: "/uploads/checkout-arrow.svg",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-xs-12 col-sm-6 pl5-ns pt5 pt0-m pt0-l ",
                              },
                              [
                                _c("img", {
                                  staticClass:
                                    "db relative center img-responsive w-100 pt4 pt0-m pt0-l",
                                  attrs: {
                                    src: _vm.page.featured_content_section
                                      .content["1"].image,
                                    alt: _vm.page.featured_content_section
                                      .content["1"].image.alt,
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "f20px is-tablet-cond-bold mt4 mb3",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.page.featured_content_section
                                          .content["1"].title
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "f15px is-tablet-regular mb3 lh-copy",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.page.featured_content_section
                                          .content["1"].text
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "f15px is-tablet-bold",
                                    attrs: {
                                      title:
                                        _vm.page.featured_content_section
                                          .content["1"].link_title,
                                      href: _vm.page.featured_content_section
                                        .content["1"].link,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.page.featured_content_section
                                          .content["1"].button_text
                                      )
                                    ),
                                    _c("simple-svg", {
                                      staticClass: "checkout",
                                      attrs: {
                                        filepath: "/uploads/checkout-arrow.svg",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }